import { GetStaticProps } from 'next'
import uniqBy from 'lodash.uniqby'
import { Option as SelectOption } from '@superhi/design/src/components/forms/inputs/SelectInput/SelectInput'

import initApollo, { API } from '../../api'

import query from './queries'

export type Props = {
  productCourseIdOptions: SelectOption<any>[]
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.Collections>({
    query,
  })

  const productCourses =
    data?.productCollections?.nodes
      .flatMap((collection) =>
        collection.variants?.nodes.map((course) =>
          course.product.__typename === 'ProductCourse'
            ? { display: course.product.title, value: course.product.id }
            : undefined,
        ),
      )
      .filter(Boolean) || []
  const uniqueProductCourses = uniqBy(productCourses, (course) => course!.value) as {
    display: string
    value: string
  }[]

  return {
    props: {
      productCourseIdOptions: [
        { display: 'Includes any course', value: null },
        ...uniqueProductCourses,
      ],
    },
  }
}
